import React, { useState } from 'react';

const BookImage = ({ src, alt, className = '', onLoad, onError }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
    if (onError) onError();
  };

  const handleLoad = (event) => {
    setHasError(false);
    if (onLoad) onLoad(event);
  };

  if (!src || hasError) {
    return (
      <div className={`${className} bg-gray-100 flex items-center justify-center`}>
        <span className="text-gray-400 text-xs">No cover</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      loading="lazy"
    />
  );
};

export default BookImage; 